import BoxDataFormatter from '../Formatters/BoxDataFormatter';
import CreditDataFormatter from '../Formatters/CreditDataFormatter';
import Tables from 'src/class/Tables';
import WeekDataFormatter from '../Formatters/WeekDataFormatter';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'id',
      label: i18n.t('pqr.ticket_number'),
      minWidth: 100,
      align: 'center',
      formatter: (row) => {
        return Formatter.strPad(row.id, 4, '0');
      },
    },
    {
      prop: 'id',
      label: '# ID',
      minWidth: 80,
      align: 'center',
      formatter: (row) => {
        return Formatter.strPad(row.id, 4, '0');
      },
    },
    {
      prop: 'type',
      label: i18n.t('common_words.type'),
      minWidth: 80,
      align: 'left',
      sortable: true,
    },
    {
      prop: 'clients.name',
      label: i18n.t('pqr.client'),
      minWidth: 100,
      align: 'left',
    },
    {
      prop: 'cutting_week',
      label: i18n.t('common_words.week'),
      minWidth: 100,
      align: 'center',
      formatter: WeekDataFormatter,
    },
    {
      label: i18n.t('production.box_data2'),
      minWidth: 200,
      align: 'left',
      formatter: BoxDataFormatter,
    },
    {
      prop: 'credit_note',
      label: i18n.t('pqr.credit_note'),
      minWidth: 110,
      align: 'left',
      formatter: CreditDataFormatter,
    },
    {
      prop: 'action_plan',
      label: i18n.t('pqr.action_plan'),
      minWidth: 110,
      align: 'left',
    },
  ];

  const Search = { ...Tables.Search };
  return { Table, Search };
};
export default configTable;
